__turbopack_context__.v({
  "degree": "EducationItem-module-scss-module__AxMi6W__degree",
  "description": "EducationItem-module-scss-module__AxMi6W__description",
  "details": "EducationItem-module-scss-module__AxMi6W__details",
  "enrolmentPeriod": "EducationItem-module-scss-module__AxMi6W__enrolmentPeriod",
  "header": "EducationItem-module-scss-module__AxMi6W__header",
  "institution": "EducationItem-module-scss-module__AxMi6W__institution",
  "institutionLogo": "EducationItem-module-scss-module__AxMi6W__institutionLogo",
  "title": "EducationItem-module-scss-module__AxMi6W__title",
});
